import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { COMPANY } from "../../config/company";
import { MenuContext } from "../../contexts/menu-context";
import "./footer.scss";

const Footer = () => {
  const { isDark } = useContext(MenuContext);
  const [isScrolled, setIsScrolled] = useState(false);
  const [createdText, setCreatedText] = useState("Készítette: FilyoDev");

  useEffect(() => {
    const scrollHandler = () => {
      if (
        document.documentElement.scrollTop >
        document.body.scrollHeight - 1400
      ) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", scrollHandler);

    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  });

  const location = useLocation();

  return location.pathname === "/f9a3c2dd20d43eda5d3e522ba2b79dfc" ? (
    <></>
  ) : (
    <div
      className={`footer ${isScrolled ? "active" : ""}`}
      style={isDark ? { background: "#000", color: "#fff" } : {}}>
      <ul>
        <li>
          &copy; {new Date().getFullYear()} {COMPANY.shortName}
        </li>
        <li>Adószám: {COMPANY.taxNumber}</li>
        <li>Cégjegyzékszám: {COMPANY.registrationNumber}</li>
        <li>
          <Link to="/impresszum">Impresszum</Link>
        </li>
        <li>
          <Link to="/aszf">ÁSZF</Link>
        </li>
        <li>
          <Link to="/adatkezelesi-tajekoztato">Adatkezelési tájékoztató</Link>
        </li>
        <li>
          <a
            href="https://www.filyodev.hu"
            target="_blank"
            onMouseEnter={() => setCreatedText("filyodev.hu")}
            onMouseLeave={() => setCreatedText("Készítette: FilyoDev")}
            rel="noreferrer">
            {createdText}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Footer;
